// extracted by mini-css-extract-plugin
module.exports = {"comp":"ActivityA2_comp__uMYRy"};